@if (collection) {
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <h2 class="visually-hidden">{{ "forms.collection.educational.title" | translate }}</h2>
    <div class="form-group">
      <label for="educationalLevels">{{ "forms.collection.educational.educationalLevels.label" | translate }}</label>
      <ng-select
        [items]="educationalLevels"
        [multiple]="true"
        [closeOnSelect]="false"
        bindLabel="value"
        id="educationalLevels"
        groupBy="children"
        labelForId="educationalLevels"
        formControlName="educationalLevels"
        (change)="educationalLevelsChange($event)">
        <ng-template ng-optgroup-tmp let-item="item">{{ item.value }}</ng-template>
        <ng-template ng-option-tmp let-item="item">{{ item.value }}</ng-template>
      </ng-select>
    </div>
    <!--educationalLevels-->
    @if (hasEarlyChildhoodEducation) {
      <h3>{{ "forms.collection.educational.headings.early" | translate }}</h3>
      <div class="form-group">
        <label for="earlyChildhoodEducationSubjects">
          {{ "forms.collection.educational.earlyChildhoodEducationSubjects.label" | translate }}
        </label>
        <ng-select
          aoeAlignmentTagDedupe
          [items]="[]"
          [multiple]="true"
          [addTag]="addEarlyChildhoodEducationSubject"
          bindLabel="targetName"
          id="earlyChildhoodEducationSubjects"
          labelForId="earlyChildhoodEducationSubjects"
        formControlName="earlyChildhoodEducationSubjects"></ng-select>
      </div>
      <!--earlyChildhoodEducationSubjects-->
      <div class="form-group">
        <label for="earlyChildhoodEducationObjectives">
          {{ "forms.collection.educational.earlyChildhoodEducationObjectives.label" | translate }}
        </label>
        <ng-select
          aoeAlignmentTagDedupe
          [items]="[]"
          [multiple]="true"
          [addTag]="addEarlyChildhoodEducationObjective"
          bindLabel="targetName"
          id="earlyChildhoodEducationObjectives"
          labelForId="earlyChildhoodEducationObjectives"
        formControlName="earlyChildhoodEducationObjectives"></ng-select>
      </div>
      <!--earlyChildhoodEducationObjectives-->
      <div class="form-group">
        <label for="earlyChildhoodEducationFramework">
          {{ "forms.collection.educational.earlyChildhoodEducationFramework.label" | translate }}
        </label>
        <input
          type="text"
          class="form-control"
          id="earlyChildhoodEducationFramework"
          formControlName="earlyChildhoodEducationFramework"
        [ngClass]="{
          'is-invalid':
            earlyChildhoodEducationFrameworkCtrl.invalid &&
            (earlyChildhoodEducationFrameworkCtrl.dirty || earlyChildhoodEducationFrameworkCtrl.touched || submitted)
        }" />
        @if (
          earlyChildhoodEducationFrameworkCtrl.invalid &&
          (earlyChildhoodEducationFrameworkCtrl.dirty || earlyChildhoodEducationFrameworkCtrl.touched || submitted)
          ) {
          <div
            class="invalid-feedback">
            @if (earlyChildhoodEducationFrameworkCtrl.errors.invalidCharacters) {
              <div>
                {{ "forms.errors.textInput.characters" | translate }}
              </div>
            }
            @if (earlyChildhoodEducationFrameworkCtrl.errors.maxlength) {
              <div>
                {{ "forms.errors.common.maxLength" | translate: { maxLength:
                earlyChildhoodEducationFrameworkCtrl.errors.maxlength.requiredLength } }}
              </div>
            }
          </div>
        }
      </div>
      <!--earlyChildhoodEducationFramework-->
    }
    <!--earlyChildhoodEducation-->
    @if (hasPrePrimaryEducation) {
      <h3>{{ "forms.collection.educational.headings.prePrimary" | translate }}</h3>
      <div class="form-group">
        <label for="prePrimaryEducationSubjects">
          {{ "forms.collection.educational.prePrimaryEducationSubjects.label" | translate }}
        </label>
        <ng-select
          aoeAlignmentTagDedupe
          [items]="[]"
          [multiple]="true"
          [addTag]="addPrePrimaryEducationSubject"
          bindLabel="targetName"
          id="prePrimaryEducationSubjects"
          labelForId="prePrimaryEducationSubjects"
        formControlName="prePrimaryEducationSubjects"></ng-select>
      </div>
      <!--prePrimaryEducationSubjects-->
      <div class="form-group">
        <label for="prePrimaryEducationObjectives">
          {{ "forms.collection.educational.prePrimaryEducationObjectives.label" | translate }}
        </label>
        <ng-select
          aoeAlignmentTagDedupe
          [items]="[]"
          [multiple]="true"
          [addTag]="addPrePrimaryEducationObjective"
          bindLabel="targetName"
          id="prePrimaryEducationObjectives"
          labelForId="prePrimaryEducationObjectives"
        formControlName="prePrimaryEducationObjectives"></ng-select>
      </div>
      <!--prePrimaryEducationObjectives-->
      <div class="form-group">
        <label for="prePrimaryEducationFramework">
          {{ "forms.collection.educational.prePrimaryEducationFramework.label" | translate }}
        </label>
        <input
          type="text"
          class="form-control"
          id="prePrimaryEducationFramework"
          formControlName="prePrimaryEducationFramework"
        [ngClass]="{
          'is-invalid':
            prePrimaryEducationFrameworkCtrl.invalid &&
            (prePrimaryEducationFrameworkCtrl.dirty || prePrimaryEducationFrameworkCtrl.touched || submitted)
        }" />
        @if (
          prePrimaryEducationFrameworkCtrl.invalid &&
          (prePrimaryEducationFrameworkCtrl.dirty || prePrimaryEducationFrameworkCtrl.touched || submitted)
          ) {
          <div
            class="invalid-feedback">
            @if (prePrimaryEducationFrameworkCtrl.errors.invalidCharacters) {
              <div>
                {{ "forms.errors.textInput.characters" | translate }}
              </div>
            }
            @if (prePrimaryEducationFrameworkCtrl.errors.maxlength) {
              <div>
                {{ "forms.errors.common.maxLength" | translate: { maxLength:
                prePrimaryEducationFrameworkCtrl.errors.maxlength.requiredLength } }}
              </div>
            }
          </div>
        }
      </div>
      <!--prePrimaryEducationFramework-->
    }
    <!--prePrimaryEducation-->
    @if (hasBasicStudies) {
      <h3>{{ "forms.collection.educational.headings.basic" | translate }}</h3>
      <div class="form-group">
        <label for="basicStudySubjects">{{ "forms.collection.educational.basicStudySubjects.label" | translate }}</label>
        <ng-select
          [items]="basicStudySubjects"
          [multiple]="true"
          [closeOnSelect]="false"
          bindLabel="targetName"
          groupBy="children"
          id="basicStudySubjects"
          labelForId="basicStudySubjects"
          formControlName="basicStudySubjects"
          (change)="basicStudySubjectsChange($event)">
          <ng-template ng-optgroup-tmp let-item="item">{{ item.targetName }}</ng-template>
          <ng-template ng-option-tmp let-item="item">{{ item.targetName }}</ng-template>
        </ng-select>
      </div>
      <!--basicStudySubjects-->
      @if (hasBasicStudySubjects) {
        <div class="form-group">
          <label for="basicStudyObjectives">
            {{ "forms.collection.educational.basicStudyObjectives.label" | translate }}
          </label>
          <ng-select
            [items]="basicStudyObjectives"
            [multiple]="true"
            [closeOnSelect]="false"
            bindLabel="targetName"
            id="basicStudyObjectives"
            groupBy="parent"
            labelForId="basicStudyObjectives"
            formControlName="basicStudyObjectives">
            <ng-template ng-optgroup-tmp let-item="item">{{ item.parent }}</ng-template>
            <ng-template ng-option-tmp let-item="item">{{ item.targetName }}</ng-template>
          </ng-select>
        </div>
        <!--basicStudyObjectives-->
        <div class="form-group">
          <label for="basicStudyContents">
            {{ "forms.collection.educational.basicStudyContents.label" | translate }}
          </label>
          <ng-select
            [items]="basicStudyContents"
            [multiple]="true"
            [closeOnSelect]="false"
            bindLabel="targetName"
            id="basicStudyContents"
            groupBy="parent"
            labelForId="basicStudyContents"
            formControlName="basicStudyContents">
            <ng-template ng-optgroup-tmp let-item="item">{{ item.parent }}</ng-template>
            <ng-template ng-option-tmp let-item="item">{{ item.targetName }}</ng-template>
          </ng-select>
        </div>
        <!--basicStudyContents-->
        <div class="form-group">
          <label for="basicStudyFramework">
            {{ "forms.collection.educational.basicStudyFramework.label" | translate }}
          </label>
          <input
            type="text"
            class="form-control"
            id="basicStudyFramework"
            formControlName="basicStudyFramework"
          [ngClass]="{
            'is-invalid':
              basicStudyFrameworkCtrl.invalid &&
              (basicStudyFrameworkCtrl.dirty || basicStudyFrameworkCtrl.touched || submitted)
          }" />
          @if (
            basicStudyFrameworkCtrl.invalid &&
            (basicStudyFrameworkCtrl.dirty || basicStudyFrameworkCtrl.touched || submitted)
            ) {
            <div
              class="invalid-feedback">
              @if (basicStudyFrameworkCtrl.errors.invalidCharacters) {
                <div>
                  {{ "forms.errors.textInput.characters" | translate }}
                </div>
              }
              @if (basicStudyFrameworkCtrl.errors.maxlength) {
                <div>
                  {{ "forms.errors.common.maxLength" | translate: { maxLength:
                  basicStudyFrameworkCtrl.errors.maxlength.requiredLength } }}
                </div>
              }
            </div>
          }
        </div>
        <!--basicStudyFramework-->
      }
    }
    <!--basicStudies-->
    <!-- preparatory education -->
    @if (hasPreparatoryEducation) {
      <h3>{{ "forms.collection.educational.headings.preparatory" | translate }}</h3>
      <div class="form-group">
        <label for="preparatoryEducationSubjects">
          {{ "forms.collection.educational.preparatoryEducationSubjects.label" | translate }}
        </label>
        <ng-select
          [items]="preparatoryEducationSubjects"
          [multiple]="true"
          [closeOnSelect]="false"
          bindLabel="targetName"
          id="preparatoryEducationSubjects"
          labelForId="preparatoryEducationSubjects"
          formControlName="preparatoryEducationSubjects"
        (change)="preparatoryEducationSubjectsChange($event)"></ng-select>
      </div>
      @if (hasPreparatoryEducationSubjects) {
        <div class="form-group">
          <label for="preparatoryEducationObjectives">
            {{ "forms.collection.educational.preparatoryEducationObjectives.label" | translate }}
          </label>
          <ng-select
            [items]="preparatoryEducationObjectives"
            [multiple]="true"
            [closeOnSelect]="false"
            bindLabel="targetName"
            groupBy="parent"
            id="preparatoryEducationObjectives"
            labelForId="preparatoryEducationObjectives"
          formControlName="preparatoryEducationObjectives"></ng-select>
        </div>
      }
    }
    <!--/preparatory education-->
    @if (hasUpperSecondarySchool) {
      <h3>{{ "forms.collection.educational.headings.upperSecondary" | translate }}</h3>
      <div class="form-group">
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            id="currentUpperSecondarySchoolSelected"
            formControlName="currentUpperSecondarySchoolSelected" />
          <label class="form-check-label" for="currentUpperSecondarySchoolSelected">
            {{ "forms.collection.educational.upperSecondarySchoolSelection.current" | translate }}
          </label>
        </div>
        <!--current-->
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            id="newUpperSecondarySchoolSelected"
            formControlName="newUpperSecondarySchoolSelected" />
          <label class="form-check-label" for="newUpperSecondarySchoolSelected">
            {{ "forms.collection.educational.upperSecondarySchoolSelection.new" | translate }}
          </label>
        </div>
        <!--new-->
      </div>
      <!--frameworkSelection-->
      @if (currentUpperSecondarySchoolSelected.value === true) {
        <h4>{{ "forms.collection.educational.upperSecondarySchoolSelection.current" | translate }}</h4>
        <div class="form-group">
          <label for="upperSecondarySchoolSubjectsOld">
            {{ "forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.new.subjects.label" |
            translate }}
          </label>
          <app-tooltip-button
            key="forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.subjects.tooltip"
            variant="help"></app-tooltip-button>
          <ng-select
            [items]="upperSecondarySchoolSubjectsOld"
            [multiple]="true"
            [closeOnSelect]="false"
            bindLabel="targetName"
            id="upperSecondarySchoolSubjectsOld"
            groupBy="parent"
            labelForId="upperSecondarySchoolSubjectsOld"
            formControlName="upperSecondarySchoolSubjectsOld"
            (change)="upperSecondarySchoolSubjectsOldChange($event)">
            <ng-template ng-optgroup-tmp let-item="item">{{ item.parent }}</ng-template>
          </ng-select>
        </div>
        <!--upperSecondarySubjectsOld-->
        @if (upperSecondarySchoolCoursesOld?.length > 0 || upperSecondarySchoolCoursesOldCtrl.value?.length > 0) {
          <div class="form-group">
            <label for="upperSecondarySchoolCoursesOld">
              {{ "forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.subjects.label" |
              translate }}
            </label>
            <ng-select
              [items]="upperSecondarySchoolCoursesOld"
              [multiple]="true"
              [closeOnSelect]="false"
              bindLabel="targetName"
              id="upperSecondarySchoolCoursesOld"
              groupBy="parent"
              labelForId="upperSecondarySchoolCoursesOld"
            formControlName="upperSecondarySchoolCoursesOld"></ng-select>
          </div>
        }
        <!--upperSecondaryCoursesOld-->
        <div class="form-group">
          <label for="upperSecondarySchoolObjectives">
            {{ "forms.collection.educational.upperSecondarySchoolObjectives.label" | translate }}
          </label>
          <ng-select
            aoeAlignmentTagDedupe
            [items]="[]"
            [multiple]="true"
            [addTag]="addUpperSecondarySchoolObjective"
            bindLabel="targetName"
            id="upperSecondarySchoolObjectives"
            labelForId="upperSecondarySchoolObjectives"
          formControlName="upperSecondarySchoolObjectives"></ng-select>
        </div>
        <!--upperSecondarySchoolObjectives-->
        <div class="form-group">
          <label for="upperSecondarySchoolFramework">
            {{ "forms.collection.educational.upperSecondarySchoolFramework.label" | translate }}
          </label>
          <input
            type="text"
            class="form-control"
            id="upperSecondarySchoolFramework"
            formControlName="upperSecondarySchoolFramework"
          [ngClass]="{
            'is-invalid':
              upperSecondarySchoolFrameworkCtrl.invalid &&
              (upperSecondarySchoolFrameworkCtrl.dirty || upperSecondarySchoolFrameworkCtrl.touched || submitted)
          }" />
          @if (
            upperSecondarySchoolFrameworkCtrl.invalid &&
            (upperSecondarySchoolFrameworkCtrl.dirty || upperSecondarySchoolFrameworkCtrl.touched || submitted)
            ) {
            <div
              class="invalid-feedback">
              @if (upperSecondarySchoolFrameworkCtrl.errors.invalidCharacters) {
                <div>
                  {{ "forms.errors.textInput.characters" | translate }}
                </div>
              }
              @if (upperSecondarySchoolFrameworkCtrl.errors.maxlength) {
                <div>
                  {{ "forms.errors.common.maxLength" | translate: { maxLength:
                  upperSecondarySchoolFrameworkCtrl.errors.maxlength.requiredLength } }}
                </div>
              }
            </div>
          }
        </div>
        <!--upperSecondarySchoolFramework-->
      }
      <!--current-->
      @if (newUpperSecondarySchoolSelected.value === true) {
        <h4>{{ "forms.collection.educational.upperSecondarySchoolSelection.new" | translate }}</h4>
        <div class="form-group">
          <label for="upperSecondarySchoolSubjectsNew">
            {{ "forms.collection.educational.upperSecondarySchoolSubjectsNew.label" | translate }}
          </label>
          <ng-select
            [items]="upperSecondarySchoolSubjectsNew"
            [multiple]="true"
            [closeOnSelect]="false"
            bindLabel="targetName"
            id="upperSecondarySchoolSubjectsNew"
            groupBy="parent"
            labelForId="upperSecondarySchoolSubjectsNew"
            formControlName="upperSecondarySchoolSubjectsNew"
            (change)="upperSecondarySchoolSubjectsNewChange($event)">
            <ng-template ng-optgroup-tmp let-item="item">{{ item.parent }}</ng-template>
          </ng-select>
        </div>
        <!--upperSecondarySchoolSubjectsNew-->
        @if (upperSecondarySchoolModulesNew?.length > 0) {
          <div class="form-group">
            <label for="upperSecondarySchoolModulesNew">
              {{ "forms.collection.educational.upperSecondarySchoolModulesNew.label" | translate }}
            </label>
            <ng-select
              [items]="upperSecondarySchoolModulesNew"
              [multiple]="true"
              [closeOnSelect]="false"
              bindLabel="targetName"
              id="upperSecondarySchoolModulesNew"
              groupBy="parent"
              labelForId="upperSecondarySchoolModulesNew"
              formControlName="upperSecondarySchoolModulesNew"
            (change)="upperSecondarySchoolModulesNewChange($event)"></ng-select>
          </div>
          <!--upperSecondarySchoolModulesNew-->
          @if (upperSecondarySchoolObjectivesNew?.length > 0) {
            <div class="form-group">
              <label for="upperSecondarySchoolObjectivesNew">
                {{ "forms.collection.educational.upperSecondarySchoolObjectivesNew.label" | translate }}
              </label>
              <ng-select
                [items]="upperSecondarySchoolObjectivesNew"
                [multiple]="true"
                [closeOnSelect]="false"
                bindLabel="targetName"
                id="upperSecondarySchoolObjectivesNew"
                groupBy="parent"
                labelForId="upperSecondarySchoolObjectivesNew"
              formControlName="upperSecondarySchoolObjectivesNew"></ng-select>
            </div>
          }
          <!--upperSecondarySchoolObjectivesNew-->
          @if (upperSecondarySchoolContentsNew?.length > 0) {
            <div class="form-group">
              <label for="upperSecondarySchoolContentsNew">
                {{ "forms.collection.educational.upperSecondarySchoolContentsNew.label" | translate }}
              </label>
              <ng-select
                [items]="upperSecondarySchoolContentsNew"
                [multiple]="true"
                [closeOnSelect]="false"
                bindLabel="targetName"
                id="upperSecondarySchoolContentsNew"
                groupBy="parent"
                labelForId="upperSecondarySchoolContentsNew"
              formControlName="upperSecondarySchoolContentsNew"></ng-select>
            </div>
          }
          <!--upperSecondarySchoolContentsNew-->
        }
      }
    }
    <!--upperSecondarySchool-->
    @if (hasVocationalEducation) {
      <h3>{{ "forms.collection.educational.headings.vocational" | translate }}</h3>
      <div class="form-group">
        <label for="vocationalDegrees">{{ "forms.collection.educational.vocationalDegrees.label" | translate }}</label>
        <ng-select
          [items]="vocationalDegrees"
          [multiple]="true"
          [closeOnSelect]="false"
          bindLabel="targetName"
          id="vocationalDegrees"
          labelForId="vocationalDegrees"
          formControlName="vocationalDegrees"
        (change)="vocationalDegreesChange($event)"></ng-select>
      </div>
      <!--vocationalDegrees-->
      <div class="form-group">
        <label for="vocationalCommonUnits">
          {{ "forms.collection.educational.vocationalCommonUnits.label" | translate }}
        </label>
        <ng-select
          [items]="subjectOfCommonUnit"
          [multiple]="true"
          [closeOnSelect]="false"
          bindLabel="targetName"
          id="vocationalCommonUnits"
          groupBy="children"
          labelForId="vocationalCommonUnits"
          formControlName="subjectOfCommonUnit">
          <ng-template ng-optgroup-tmp let-item="item">{{ item.targetName }}</ng-template>
          <ng-template ng-option-tmp let-item="item">{{ item.targetName }}</ng-template>
        </ng-select>
      </div>
      @if (hasVocationalDegrees) {
        <div class="form-group">
          <label for="vocationalUnits">{{ "forms.collection.educational.vocationalUnits.label" | translate }}</label>
          <ng-select
            [items]="vocationalUnits"
            [multiple]="true"
            [closeOnSelect]="false"
            bindLabel="targetName"
            id="vocationalUnits"
            groupBy="parent"
            labelForId="vocationalUnits"
            formControlName="vocationalUnits"
          (change)="vocationalUnitsChange($event)"></ng-select>
        </div>
        <!--vocationalUnits-->
        <div class="form-group">
          <label for="vocationalRequirements">
            {{ "forms.collection.educational.vocationalEducationObjectives.label" | translate }}
          </label>
          <ng-select
            aoeAlignmentTagDedupe
            [items]="vocationalRequirements"
            [multiple]="true"
            [closeOnSelect]="false"
            [addTag]="addVocationalEducationObjective"
            bindLabel="targetName"
            id="vocationalRequirements"
            groupBy="parent"
            labelForId="vocationalRequirements"
          formControlName="vocationalRequirements"></ng-select>
        </div>
        <!--vocationalEducationObjectives-->
        <div class="form-group">
          <label for="vocationalEducationFramework">
            {{ "forms.collection.educational.vocationalEducationFramework.label" | translate }}
          </label>
          <input
            type="text"
            class="form-control"
            id="vocationalEducationFramework"
            formControlName="vocationalEducationFramework"
          [ngClass]="{
            'is-invalid':
              vocationalEducationFrameworkCtrl.invalid &&
              (vocationalEducationFrameworkCtrl.dirty || vocationalEducationFrameworkCtrl.touched || submitted)
          }" />
          @if (
            vocationalEducationFrameworkCtrl.invalid &&
            (vocationalEducationFrameworkCtrl.dirty || vocationalEducationFrameworkCtrl.touched || submitted)
            ) {
            <div
              class="invalid-feedback">
              @if (vocationalEducationFrameworkCtrl.errors.invalidCharacters) {
                <div>
                  {{ "forms.errors.textInput.characters" | translate }}
                </div>
              }
              @if (vocationalEducationFrameworkCtrl.errors.maxlength) {
                <div>
                  {{ "forms.errors.common.maxLength" | translate: { maxLength:
                  vocationalEducationFrameworkCtrl.errors.maxlength.requiredLength } }}
                </div>
              }
            </div>
          }
        </div>
        <!--vocationalEducationFramework-->
      }
    }
    <!--vocationalEducation-->
    @if (hasSelfMotivatedEducation) {
      <h3>{{ "forms.collection.educational.headings.selfMotivated" | translate }}</h3>
      <div class="form-group">
        <label for="selfMotivatedEducationSubjects">
          {{ "forms.collection.educational.selfMotivatedEducationSubjects.label" | translate }}
        </label>
        <ng-select
          aoeAlignmentTagDedupe
          [items]="[]"
          [multiple]="true"
          [addTag]="addSelfMotivatedEducationSubject"
          bindLabel="targetName"
          id="selfMotivatedEducationSubjects"
          labelForId="selfMotivatedEducationSubjects"
        formControlName="selfMotivatedEducationSubjects"></ng-select>
      </div>
      <!--selfMotivatedEducationSubjects-->
      <div class="form-group">
        <label for="selfMotivatedEducationObjectives">
          {{ "forms.collection.educational.selfMotivatedEducationObjectives.label" | translate }}
        </label>
        <ng-select
          aoeAlignmentTagDedupe
          [items]="[]"
          [multiple]="true"
          [addTag]="addSelfMotivatedEducationObjective"
          bindLabel="targetName"
          id="selfMotivatedEducationObjectives"
          labelForId="selfMotivatedEducationObjectives"
        formControlName="selfMotivatedEducationObjectives"></ng-select>
      </div>
      <!--selfMotivatedEducationObjectives-->
    }
    <!--selfMotivatedEducation-->
    @if (hasHigherEducation) {
      <h3>{{ "forms.collection.educational.headings.higher" | translate }}</h3>
      <div class="form-group">
        <label for="scienceBranches">{{ "forms.collection.educational.scienceBranches.label" | translate }}</label>
        <ng-select
          [items]="scienceBranches"
          [multiple]="true"
          [closeOnSelect]="false"
          [selectableGroup]="true"
          [selectableGroupAsModel]="false"
          bindLabel="targetName"
          id="scienceBranches"
          groupBy="children"
          labelForId="scienceBranches"
          formControlName="scienceBranches">
          <ng-template ng-optgroup-tmp let-item="item">{{ item.targetName }}</ng-template>
          <ng-template ng-option-tmp let-item="item">{{ item.targetName }}</ng-template>
        </ng-select>
      </div>
      <!--scienceBranches-->
      <div class="form-group">
        <label for="scienceBranchObjectives">
          {{ "forms.collection.educational.scienceBranchObjectives.label" | translate }}
        </label>
        <ng-select
          aoeAlignmentTagDedupe
          [items]="[]"
          [multiple]="true"
          [addTag]="addScienceBranchObjectives"
          bindLabel="targetName"
          id="scienceBranchObjectives"
          labelForId="scienceBranchObjectives"
        formControlName="scienceBranchObjectives"></ng-select>
      </div>
      <!--scienceBranchObjectives-->
      <div class="form-group">
        <label for="higherEducationFramework">
          {{ "forms.collection.educational.higherEducationFramework.label" | translate }}
        </label>
        <input
          type="text"
          class="form-control"
          id="higherEducationFramework"
          formControlName="higherEducationFramework"
        [ngClass]="{
          'is-invalid':
            higherEducationFrameworkCtrl.invalid &&
            (higherEducationFrameworkCtrl.dirty || higherEducationFrameworkCtrl.touched || submitted)
        }" />
        @if (
          higherEducationFrameworkCtrl.invalid &&
          (higherEducationFrameworkCtrl.dirty || higherEducationFrameworkCtrl.touched || submitted)
          ) {
          <div
            class="invalid-feedback">
            @if (higherEducationFrameworkCtrl.errors.invalidCharacters) {
              <div>
                {{ "forms.errors.textInput.characters" | translate }}
              </div>
            }
            @if (higherEducationFrameworkCtrl.errors.maxlength) {
              <div>
                {{ "forms.errors.common.maxLength" | translate: { maxLength:
                higherEducationFrameworkCtrl.errors.maxlength.requiredLength } }}
              </div>
            }
          </div>
        }
      </div>
      <!--higherEducationFramework-->
    }
    <!--higherEducation-->
    <div class="row">
      <div class="col">
        <button type="button" class="btn btn-gray" (click)="previous()">{{ "forms.common.previous" | translate }}</button>
      </div>
      <div class="col-auto">
        <button type="reset" class="btn btn-cancel" (click)="emitAbort()">{{ "forms.common.abort" | translate }}</button>
      </div>
      <div class="col-auto">
        <button type="submit" class="btn btn-blue">{{ "forms.common.next" | translate }}</button>
      </div>
    </div>
  </form>
}
